module.exports = __webpack_public_path__ + "media/images/country_flags/tt-054f802f98196f86098c9d51096a10cd.png";